import React from 'react';
import ReactDOM from 'react-dom/client';

// Design System imports (order matters)
import './styles/variables.css';
import './styles/base.css';
import './styles/animations.css';
import './styles/responsive.css';

// App styles
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);